import {loadable} from 'router/routes';
import getInitialState from './redux/get-initial-state';

const ParkingPass = loadable(() => import('./ParkingPass'));

ParkingPass.getInitialState = getInitialState;

export default ParkingPass;
